import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ImageUtils } from '../../utils/image.utils';
import { IAdditionalItemField } from '../../models/common.models';

@Component({
  selector: 'app-quote-item-with-ivk-form',
  templateUrl: './quote-item-with-ivk-form.component.html',
  styleUrls: ['./quote-item-with-ivk-form.component.scss'],
  standalone: false,
})
export class QuoteItemWithIvkFormComponent {
  @Input() item: any;
  @Input() installBaseLoading: any;
  @Input() systems: any[] = [];
  @Input() businessUnits: any[] = [] as Array<{name: string, value: string}>;
  @Input() businessUnitLoading: boolean = false;
  @Input() additionalFields: any[] = [] as Array<IAdditionalItemField>;

  @Output() formChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() formHidden: EventEmitter<any> = new EventEmitter<any>();

  separateSystemChecked: boolean = false;

  getProductImageUrl(): string {
    return ImageUtils.getProductImageUrl(this.item);
  }

  toggleForm(event: any): void {
    this.separateSystemChecked = event.target.checked;

    if (!this.separateSystemChecked) {
      this.formHidden.emit(this.item.id);
    }
  }

  onFormChange(form: UntypedFormGroup): void {
    this.formChanged.emit({
      itemId: this.item.id,
      formGroup: form
    });
  }
}
